window.addEventListener('DOMContentLoaded', (event) => {

  if (document.querySelector("#CartGiftWrap")) {

    const cart = document.querySelector("#CartDrawer");
    const cartItemsContainer = cart.querySelectorAll('[data-products]');

    const giftWrap = document.querySelector("#CartGiftWrap");
    const giftWrapChooseOptions = giftWrap.querySelector('[data-gift-wrap-options-button]');
    const giftWrapOptionsSelect = giftWrap.querySelector('[data-gift-wrap-options-select]');
    const giftWrapDetails = giftWrap.querySelector('[data-gift-wrap-details]');
    const giftWrapAddToCart = giftWrap.querySelector('[data-gift-wrap-add-to-cart]');
    const giftWrapImage = giftWrap.querySelector('[data-gift-wrap-image]');
    const giftWrapProductId = giftWrap.dataset.giftWrapProductId;

    giftWrapChooseOptions.addEventListener("click", e => {
      showDetails();
    });

    giftWrapAddToCart.addEventListener("click", e => {
      if (getGiftWrapVariantIdInCart()) {
        updateGiftWrap();
      }
      else {
        addGiftWrap();
      }
    });

    giftWrapOptionsSelect.addEventListener("change", e => {
      const select = giftWrapOptionsSelect;
      const selectedItem = select.querySelector("option:checked");
      const variantId = selectedItem.dataset.variantid;
      const variantImage = selectedItem.dataset.variantimage;
      const variantPrice = selectedItem.dataset.variantprice;

      giftWrapImage.src = variantImage;

    });

    function showDetails() {

      giftWrapChooseOptions.classList.add("hide");
      giftWrapDetails.classList.remove("hide");

    }

    function hideDetails() {

      giftWrapChooseOptions.classList.remove("hide");
      giftWrapDetails.classList.add("hide");

    }

    function addGiftWrap() {

      const button = giftWrapAddToCart;
      const selectedItem = giftWrapOptionsSelect.querySelector("option:checked");
      const selectedVariantId = selectedItem.dataset.variantid;

      const properties = {};

      if (giftWrap.querySelector("#wrap-individually").checked == true) {
        properties['Wrap Individually'] = "Yes";
      }

      if (giftWrap.querySelector("#label-packages").checked == true) {
        properties['Label gifts with names'] = "Yes";
      }

      const data = {
        'id': selectedVariantId,
        'quantity': 1,
        'properties': properties
      };

      button.classList.add("btn--loading");

      fetch('/cart/add.js', {
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST'
      }).then(function(response) {

        return response.json();

      }).then(function(json) {

        button.classList.remove("btn--loading");

        document.dispatchEvent(new Event("cart:build"));

      }).catch(function(err) {

        button.classList.remove("btn--loading");

        document.dispatchEvent(new Event("cart:build"));

      });

    }

    function getGiftWrapVariantIdInCart() {

      const cartItems = cart.querySelectorAll('[data-products] .cart__item');

      for (let i = 0; i < cartItems.length; i++) {
        const item = cartItems[i];
        const productId = item.dataset.productId;
        const variantId = item.dataset.variantId;

        if (giftWrapProductId == productId) {
          giftWrapVariantId = variantId;
          return giftWrapVariantId;
        }
      }

    }

    function updateGiftWrap() {
      
      const button = giftWrapAddToCart;

      const updates = {};

      let giftWrapVariantId = getGiftWrapVariantIdInCart();

      updates[giftWrapVariantId] = 0;

      const data = {
        updates: updates
      };

      button.classList.add("btn--loading");

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST'
      }).then(function(response) {

        return response.json();

      }).then(function(json) {

        button.classList.remove("btn--loading");
        document.dispatchEvent(new Event("cart:build"));

        addGiftWrap();

      }).catch(function(err) {

        button.classList.remove("btn--loading");
        document.dispatchEvent(new Event("cart:build"));

      });

    }

    function cartUpdate(e) {

      console.log("cartUpdate");

      const giftWrap = document.querySelector("#CartGiftWrap");

      console.log(getGiftWrapVariantIdInCart());

      if (getGiftWrapVariantIdInCart()) {
        giftWrapVariantId = getGiftWrapVariantIdInCart();
        giftWrap.classList.add("hide");
      }
      else {
        giftWrap.classList.remove("hide");
      }

      hideDetails();

    };

    document.addEventListener('cart:updated:finished', cartUpdate);

  }

});